import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";
import React from "react";
import { HelmetDexteel } from "@dexteel/mesf-core";

export interface ConfirmationDialogRawProps {
	title: string;
	message?: string;
	open: boolean;
	onClose: (value?: string) => void;
	suffixTitle?: string;
}
export const ConfirmationDialogRaw = ({
	title,
	message,
	open,
	onClose,
	suffixTitle,
	...other
}: ConfirmationDialogRawProps) => {
	const handleCancel = () => {
		onClose("Cancel");
	};
	const handleOk = () => {
		onClose("OK");
	};
	return (
		<>
			{open && (
				<HelmetDexteel
					title={`${title}${suffixTitle ? ` - ${suffixTitle}` : ""}`}
				/>
			)}
			<Dialog maxWidth="xs" open={open} {...other}>
				<DialogTitle>{title}</DialogTitle>
				<DialogContent dividers>
					<DialogContentText>{message}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						variant="contained"
						size="small"
						autoFocus
						onClick={handleCancel}
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						size="small"
						color="primary"
						onClick={handleOk}
					>
						Ok
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};
